const normalizeBase = (backendUrl) => (backendUrl || '').replace(/\/+$/, '');

const authHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...(token ? { Authorization: `Bearer ${token}` } : {})
});

async function requestJson(url, options = {}) {
  const res = await fetch(url, options);
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch (e) {
    data = { raw: text };
  }
  if (!res.ok) {
    const message = data?.error || data?.message || `HTTP ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data;
}

export async function listSources({ backendUrl, userId, token, sourceType, search = '', ownOnly = false, scope = '', limit = 100, offset = 0 }) {
  const base = normalizeBase(backendUrl);
  const params = new URLSearchParams();
  if (sourceType) params.set('type', sourceType);
  if (search) params.set('search', search);
  params.set('own_only', ownOnly ? 'true' : 'false');
  if (scope) params.set('scope', scope);
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return requestJson(`${base}/api/user/${userId}/sources?${params.toString()}`, {
    headers: authHeaders(token)
  });
}

export async function getSource({ backendUrl, userId, token, sourceId }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/sources/${sourceId}`, {
    headers: authHeaders(token)
  });
}

export async function createSource({ backendUrl, userId, token, payload }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/sources`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(payload)
  });
}

export async function updateSourceMeta({ backendUrl, userId, token, sourceId, payload }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/sources/${sourceId}`, {
    method: 'PATCH',
    headers: authHeaders(token),
    body: JSON.stringify(payload)
  });
}

export async function updateSourceContent({ backendUrl, userId, token, sourceId, payload }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/sources/${sourceId}/content`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify(payload)
  });
}

export async function cloneSource({ backendUrl, userId, token, sourceId }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/sources/${sourceId}/clone`, {
    method: 'POST',
    headers: authHeaders(token)
  });
}

export async function deleteSource({ backendUrl, userId, token, sourceId }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/sources/${sourceId}`, {
    method: 'DELETE',
    headers: authHeaders(token)
  });
}

export async function getSourceSelection({ backendUrl, userId, token }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/source-selection`, {
    headers: authHeaders(token)
  });
}

export async function updateSourceSelection({ backendUrl, userId, token, payload }) {
  const base = normalizeBase(backendUrl);
  return requestJson(`${base}/api/user/${userId}/source-selection`, {
    method: 'PUT',
    headers: authHeaders(token),
    body: JSON.stringify(payload)
  });
}

